import { useCallback, useEffect, useState } from "react";
import { ApiRequestError, fetchSession } from "../lib/api";
import type { SessionState } from "../types";

export interface SessionHook {
  session: SessionState | null;
  loading: boolean;
  error: string | null;
  refresh: () => Promise<void>;
}

export function useSession(): SessionHook {
  const [session, setSession] = useState<SessionState | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const next = await fetchSession();
      setSession(next);
      setError(null);
    } catch (err) {
      const message = err instanceof ApiRequestError ? err.message : "Unable to load session.";
      setError(message);
      setSession(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return { session, loading, error, refresh };
}
